import { render, staticRenderFns } from "./epb-slide.component.vue?vue&type=template&id=0d317ea1&scoped=true"
import script from "./epb-slide.component.vue?vue&type=script&lang=ts"
export * from "./epb-slide.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-slide.component.vue?vue&type=style&index=0&id=0d317ea1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d317ea1",
  null
  
)

export default component.exports